import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Only use StrictMode in development to avoid double rendering in production
// This improves TTI (Time to Interactive) on mobile devices
if (process.env.NODE_ENV === 'production') {
  root.render(<App />);
} else {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// Defer web vitals reporting to improve TTI (Time to Interactive)
// Report metrics after initial render to avoid blocking main thread
if (process.env.NODE_ENV === 'production') {
  // In production, defer web vitals to avoid blocking TTI
  setTimeout(() => {
    reportWebVitals();
  }, 0);
} else {
  // In development, report immediately for debugging
  reportWebVitals();
}
